import { BooleanValueSettings } from '@tap/data-providers';
import { ValueProps } from './values.types';
import { Typography } from '@mui/material';

export const BooleanValue = ({ value, settings = {} }: ValueProps<boolean, BooleanValueSettings>) => {

    const { trueText = 'Да', falseText = 'Нет', emptyText = '-' } = settings;

    if (value === undefined || value === null) {
        return (
            <Typography>{emptyText}</Typography>
        );
    }

    return (
        <Typography>{value ? trueText : falseText}</Typography>
    );
}